<div class="container">
    <mat-card>
        <h2 mat-title>Listado transacciones del cajero</h2>
        <form [formGroup]="htmlForm" (ngSubmit)="submit()">
            <mat-card-content fxLayout="row" style="visibility: hidden; height: 0px;">
                <mat-form-field fxFlex="50%" (click)="txDateFromDatePicker.open()">
                    <mat-label>Fecha inicial</mat-label>
                    <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="txDateFromDatePicker" required
                        formControlName="txnDateFrom" [ngModel]="txnDateFrom" (ngModelChange)="applyFilter()">
                    <mat-datepicker-toggle matSuffix [for]="txDateFromDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #txDateFromDatePicker></mat-datepicker>
                    <mat-error *ngIf="htmlForm.controls.txnDateFrom.hasError('required')">
                        Fechas es <strong>obligatoria</strong>
                    </mat-error>
                </mat-form-field>
                &nbsp;&nbsp;&nbsp;
                <mat-form-field fxFlex="50%" (click)="txDateToDatePicker.open()">
                    <mat-label>Fecha final</mat-label>
                    <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="txDateToDatePicker" required
                        formControlName="txnDateTo" [ngModel]="txnDateTo" (ngModelChange)="applyFilter()">
                    <mat-datepicker-toggle matSuffix [for]="txDateToDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #txDateToDatePicker></mat-datepicker>
                    <mat-error *ngIf="htmlForm.controls.txnDateTo.hasError('required')">
                        Fecha es <strong>obligatoria</strong>
                    </mat-error>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">

                <table mat-table [dataSource]="cashierTransactionsList"  matSort (matSortChange)="announceSortChange($event)">

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                    <tr mat-row *matRowDef="let currObj; columns: columnsToDisplay"></tr>

                    <!--ng-container matColumnDef="txnDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                        <td mat-cell *matCellDef="let obj"> {{obj.txnDate | date: 'MM/dd/yyyy'}} </td>
                    </ng-container-->
                    
                    <ng-container matColumnDef="txnTime">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Hora </th>
                        <td mat-cell *matCellDef="let obj"> {{obj.txnTime}} </td>
                    </ng-container>                    
                    
                    <ng-container matColumnDef="txnTypeName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
                        <td mat-cell *matCellDef="let obj"> {{obj.txnTypeName}} </td>
                    </ng-container>                      

                    <ng-container matColumnDef="causal">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Causal </th>
                        <td mat-cell *matCellDef="let obj"> {{obj.causal?.toString().replace('999','Pago a préstamo')}} </td>
                    </ng-container>        
                    
                    <ng-container matColumnDef="txnAmount">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: right;"> Monto&nbsp;&nbsp;</th>
                        <td mat-cell *matCellDef="let obj"  style="text-align: right;"> {{obj.txnAmount | number: '1.2-2'}}&nbsp;&nbsp;</td>
                    </ng-container>       
                    
                    <ng-container matColumnDef="currencyAcronym">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Moneda </th>
                        <td mat-cell *matCellDef="let obj"> {{obj.currencyAcronym}} </td>
                    </ng-container>                           

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef >Acción</th>   
                        <mat-cell *matCellDef="let myRowData">
                            <button mat-raised-button color="error" *ngIf="myRowData.reversed" (enabled)="false" style="width:100px">Revertido</button>
                            <button mat-raised-button color="primary" *ngIf="!myRowData.reversed"  style="width:100px" 
                                    (click)="revertTransaction({
                                        'transactionId':myRowData.transactionId,
                                        'origin':myRowData.origin,
                                        'txnAmount':myRowData.txnAmount,
                                        'currencyAcronym': myRowData.currencyAcronym,
                                        'entityId': myRowData.entityId
                                    })">Revertir</button>

                        </mat-cell>
                    </ng-container>

                </table>
                <mat-paginator></mat-paginator>

                <mat-card-actions fxLayoutGap="5px" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
                    <button type="button" mat-raised-button [routerLink]="['/home']">Cancelar</button>
                </mat-card-actions>
                                       
            </mat-card-content>
        </form>
    </mat-card>
</div>